// @flow
import invariant from 'invariant';
import * as React from 'react';
import MultiPill from 'components/MultiPill';
import Field from './Field';

const MultiPillField = ({
  name,
  label,
  description,
  value,
  ...inputProps
}: {
  name: string,
  label?: string,
  description?: string,
  value: Array<string>,
  idToLabelMap: { [string]: ?string },
  onDelete: number => void
}) => (
  <Field
    name={name}
    inputProps={inputProps}
    label={label}
    description={description}
    renderInput={({ qaId }) => {
      invariant(Array.isArray(value), 'Invalid value for MultiPillField');
      return <MultiPill values={value} data-qa-id={qaId} {...inputProps} />;
    }}
  />
);

export default MultiPillField;
